import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LogService, FilteredLogSubscriberService, LogMessage, LogLevel } from './log.service';
import { ConsoleLogSubscriberService } from './console-log-subscriber.service';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { Subject } from 'rxjs/Subject';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FlashMessagesService } from '../flash-messages/service/flash.messages.service';
import { Router } from '@angular/router';
import { timer } from 'rxjs/observable/timer';

@Injectable()
export class HttpLogSubscriberService extends FilteredLogSubscriberService implements OnDestroy {

  readonly errorUrl = `${this.environment.baseUrl}/api/error`;
  readonly HTTP_ERROR_MSG = 'HttpLogSubscriberService - Could not stream message to the server;';

  private onDestroy$ = new Subject<void>();
  private requestCount = 0;

  constructor(logService: LogService,
              private http: HttpClient,
              private consoleLogSubscriber: ConsoleLogSubscriberService,
              private translateService: TranslateService,
              private flashMessagesService: FlashMessagesService,
              private router: Router,
              private environment: EnvironmentConfiguration) {
    super(logService);
  }

  public async log(logMessage: LogMessage) {
    let bodyString = JSON.stringify(logMessage); // Stringify payload
    let headers = new HttpHeaders({'Content-Type': 'application/json'}); // ... Set content type to JSON
    // TODO: Add meta information to the error so it can be identified on
    // the server and correlated to other errors.
    // headers.append('SessionId', user.sessionId)
    // headers.append('UserId', user.userId)
    let options = {headers: headers}; // Create a request option

    this.requestCount++;
    if (this.requestCount > 10) {
      await this.router.navigate(['/dashboard']);
      await this.flashMessagesService.warn(this.translateService.instant('MESSAGES.ERROR.GENERIC_ERROR_TOO_MANY_REQUEST'));
      return;
    }

    if (this.requestCount === 1) {
      // If it is the first request, a timer is started to reset the counter after 1.5 second.
      timer(1500)
        .pipe(
          takeUntil(this.onDestroy$)
        )
        .subscribe(() => {
          this.requestCount = 0;
        });
    }

    const post = this.http.post(this.errorUrl, bodyString, options);
    return post.pipe(
      takeUntil(this.onDestroy$)
    ).subscribe((response) => {
    }, (error) => {
      this.consoleLogSubscriber.log(
        new LogMessage(LogLevel.ERROR, this.HTTP_ERROR_MSG + error)
      );
      this.consoleLogSubscriber.log(logMessage);
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/log/http-log-subscriber.service.ts